module.exports = __webpack_public_path__ + "static/media/flower.4c773095.png";